import React, { Component } from 'react'
import moment from 'moment'
import Footer from '../spexpo/Footer'
import Banner from '../spexpo/Banner'
import Header from '../spexpo/Header'
import ShowCard from '../spexpo/ShowCard'
import '../static/css/style.css'
import '../static/css/spexpo.css'

export default class SaoPauloExpo extends Component {
  constructor () {
    super()
    this.state = {
      organizador: { id: 48, name: 'Parceria Evnts e São Paulo Expo' },
      events: [
        {
          id: 1795,
          eventName: 'FEICON BATIMAT',
          address: '1,5 - Rod. dos Imigrantes - Vila Água Funda, São Paulo - SP, 04329-900',
          startDate: '2020-03-31',
          endDate: '2020-04-03',
          urlFriendly: 'spexpo-feicon-batimat'
        }, {
          id: 1796,
          eventName: 'ECOENERGY',
          address: '1,5 - Rod. dos Imigrantes - Vila Água Funda, São Paulo - SP, 04329-900',
          startDate: '2020-04-14',
          endDate: '2020-04-16',
          urlFriendly: 'spexpo-ecoenergy'
        }, {
          id: 1797,
          eventName: 'EXPOSEC',
          address: '1,5 - Rod. dos Imigrantes - Vila Água Funda, São Paulo - SP, 04329-900',
          startDate: '2020-04-14',
          endDate: '2020-04-16',
          urlFriendly: 'spexpo-exposec'
        }, {
          id: 1798,
          eventName: 'VTEX DAY',
          address: '1,5 - Rod. dos Imigrantes - Vila Água Funda, São Paulo - SP, 04329-900',
          startDate: '2020-04-15',
          endDate: '2020-04-16',
          urlFriendly: 'spexpo-vtex-day'
        }, {
          id: 1799,
          eventName: 'FEIMEC',
          address: '1,5 - Rod. dos Imigrantes - Vila Água Funda, São Paulo - SP, 04329-900',
          startDate: '2020-05-05',
          endDate: '2020-05-09',
          urlFriendly: 'spexpo-feimec'
        }, {
          id: 1800,
          eventName: 'HOSPITALAR',
          address: '1,5 - Rod. dos Imigrantes - Vila Água Funda, São Paulo - SP, 04329-900',
          startDate: '2020-05-19',
          endDate: '2020-05-22',
          urlFriendly: 'spexpo-hospitalar'
        }, {
          id: 1852,
          eventName: 'FCE COSMETIQUE 2020',
          address: '1,5 - Rod. dos Imigrantes - Vila Água Funda, São Paulo - SP, 04329-900',
          startDate: '2020-06-02',
          endDate: '2020-06-04',
          urlFriendly: 'spexpo-fce-cosmetique-2020'
        }, {
          id: 1851,
          eventName: 'FCE PHARMA 2020',
          address: '1,5 - Rod. dos Imigrantes - Vila Água Funda, São Paulo - SP, 04329-900',
          startDate: '2020-06-02',
          endDate: '2020-06-04',
          urlFriendly: 'spexpo-fce-pharma-2020'
        }, {
          id: 1853,
          eventName: 'GLASS SOUTH AMERICA 2020',
          address: '1,5 - Rod. dos Imigrantes - Vila Água Funda, São Paulo - SP, 04329-900',
          startDate: '2020-06-03',
          endDate: '2020-06-06',
          urlFriendly: 'spexpo-glass-south-america-2020'
        }, {
          id: 1854,
          eventName: 'FISPAL TECNOLOGIA 2020',
          address: '1,5 - Rod. dos Imigrantes - Vila Água Funda, São Paulo - SP, 04329-900',
          startDate: '2020-06-16',
          endDate: '2020-06-19',
          urlFriendly: 'spexpo-fispal-tecnologia-2020'
        }, {
          id: 1855,
          eventName: 'SMART.CON 2020',
          address: '1,5 - Rod. dos Imigrantes - Vila Água Funda, São Paulo - SP, 04329-900',
          startDate: '2020-06-17',
          endDate: '2020-06-18',
          urlFriendly: 'spexpo-smart-con-2020'
        }, {
          id: 1856,
          eventName: 'FORMOBILE 2020',
          address: '1,5 - Rod. dos Imigrantes - Vila Água Funda, São Paulo - SP, 04329-900',
          startDate: '2020-06-30',
          endDate: '2020-07-03',
          urlFriendly: 'spexpo-formobile-2020'
        }, {
          id: 1857,
          eventName: 'FESTIVAL DO JAPÃO 2020',
          address: '1,5 - Rod. dos Imigrantes - Vila Água Funda, São Paulo - SP, 04329-900',
          startDate: '2020-07-10',
          endDate: '2020-07-12',
          urlFriendly: 'spexpo-festival-do-japao-2020'
        }, {
          id: 1858,
          eventName: 'MEGA ARTESANAL 2020',
          address: '1,5 - Rod. dos Imigrantes - Vila Água Funda, São Paulo - SP, 04329-900',
          startDate: '2020-07-31',
          endDate: '2020-08-05',
          urlFriendly: 'spexpo-mega-artesanal-2020'
        }, {
          id: 1859,
          eventName: 'CONARH 2020',
          address: '1,5 - Rod. dos Imigrantes - Vila Água Funda, São Paulo - SP, 04329-900',
          startDate: '2020-08-11',
          endDate: '2020-08-13',
          urlFriendly: 'spexpo-conarh-2020'
        }, {
          id: 1860,
          eventName: 'PET SOUTH AMERICA 2020',
          address: '1,5 - Rod. dos Imigrantes - Vila Água Funda, São Paulo - SP, 04329-900',
          startDate: '2020-08-19',
          endDate: '2020-08-21',
          urlFriendly: 'spexpo-pet-south-america-2020'
        }, {
          id: 1861,
          eventName: 'POLISHOP INNOVATION SHOW 2020',
          address: '1,5 - Rod. dos Imigrantes - Vila Água Funda, São Paulo - SP, 04329-900',
          startDate: '2020-09-05',
          endDate: '2020-09-07',
          urlFriendly: 'spexpo-polishop-innovation-show-2020'
        }, {
          id: 1862,
          eventName: 'FESQUA 2020',
          address: '1,5 - Rod. dos Imigrantes - Vila Água Funda, São Paulo - SP, 04329-900',
          startDate: '2020-09-16',
          endDate: '2020-09-19',
          urlFriendly: 'spexpo-fesqua-2020'
        }, {
          id: 1863,
          eventName: 'SÃO PAULO BOAT SHOW 2020',
          address: '1,5 - Rod. dos Imigrantes - Vila Água Funda, São Paulo - SP, 04329-900',
          startDate: '2020-09-25',
          endDate: '2020-09-30',
          urlFriendly: 'spexpo-sao-paulo-boat-show-2020'
        }
      ],
      loaded: false,
      error: false
    }
  }

  componentDidMount () {
    this.setState({ eventsFiltered: this.state.events.filter(evento => moment(evento.endDate) >= moment()) })
  }

  render () {
    document.title = this.state.organizador.name || 'Carregando...'

    return (
      <div>
        <main>
          <Header />
          <Banner />
          <section id='hotels'>
            <div style={{
              flex: '0 0 100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '20px 0'
            }}>
              <select className='filtro' name='filtro' id='filtro' onChange={e => {
                this.setState({ eventsFiltered: e.target.value === '-1' ? this.state.events.filter(x => moment(x.endDate) >= moment()) : this.state.events.filter(x => moment(x.endDate) >= moment()).filter(x => moment(x.startDate).month() === ~~e.target.value) })
              }}>
                <option value='-1'>Sem filtro</option>
                <option value='0'>Jan</option>
                <option value='1'>Fev</option>
                <option value='2'>Mar</option>
                <option value='3'>Abr</option>
                <option value='4'>Mai</option>
                <option value='5'>Jun</option>
                <option value='6'>Jul</option>
                <option value='7'>Ago</option>
                <option value='8'>Set</option>
                <option value='9'>Out</option>
                <option value='10'>Nov</option>
                <option value='11'>Dez</option>
              </select>
            </div>
            {this.state.eventsFiltered && (this.state.eventsFiltered).map(event => <ShowCard key={event.id} organizador={this.state.organizador.id} {...event} />)}
          </section>
        </main>
        <Footer />
      </div>
    )
  }
}
